import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getConfiguracion() {
    return this.http.get(this.myAppUrl + 'api/configuracion');
  }

  getIdioma() {
    return this.http.get(this.myAppUrl + 'api/configuracion/idioma');
  }
}
